import React from 'react'
import Wave from 'react-wavify'
import arrow from '../../Image/below_arrow.svg'
import tool from '../../Image/tool.svg'
import box from '../../Image/box.svg'
import psd from '../../Image/psd.svg'
import cross from '../../Image/Service/Cross-Arrow.svg'

const DesignService = () => {
  return (
    <div className='overflow-hidden'>
    <Wave fill='#F6F6F6' paused={false} style={{ display: 'flex' }} options={{ height: 20, amplitude: 20, speed: 0.3, points: 5}} className='relative min-w-[1920px] h-[30px]'/>
    <section className="bg-[#F6F6F6] px-6 sm:px-0 py-10 pb-0">
        <div className="container mx-auto">
            <h2 className="text-xl font-bold text-black mb-2 sm:mt-5">OUR UX/UI DESIGN SERVICES</h2>
            <div className="flex flex-wrap -mx-3 mt-5">
                    <div className="w-full lg:w-1/2 p-0 sm:px-3 mb-6 mt-3">
                        <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-100 hover:shadow-purple-md hover:cursor-pointer transition duration-300 ease-in-out relative h-full">
                            <div className="absolute top-4 right-4 bg-gradient-to-tr bg-[#F0E3FF] p-2 rounded-full"><img src={cross} alt="crossArrow" className="w-4 h-4" /></div>
                             <div className='flex sm:flex-nowrap flex-wrap items-center'>
                                 <div className='sm:w-1/6'>
                                    <div className=""><img src={arrow} alt="Web Dev Icon" className='sm:w-[80px] w-[60px]' /></div>
                                 </div>
                                 <div className='sm:w-4/5 2xl:px-0 lg:px-5 md:px-0 sm:px-5 sm:mt-0 mt-3'>
                                    <h3 className="text-[18px] font-bold text-black mb-2">Responsive Web Design Development</h3>
                                    <p className="text-sm text-gray-600">With latest design standards, we make the design accessible on all platforms.</p>
                                 </div>
                             </div>
                           
                        </div>
                    </div>
                    <div className="w-full  lg:w-1/2 p-0 sm:px-3 mb-6 lg:mt-3">
                        <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-100 hover:shadow-purple-md hover:cursor-pointer transition duration-300 ease-in-out relative h-full">
                            <div className="absolute top-4 right-4 bg-gradient-to-tr bg-[#F0E3FF] p-2 rounded-full"><img src={cross} alt="crossArrow" className="w-4 h-4" /></div>
                             <div className='flex sm:flex-nowrap flex-wrap items-center'>
                                 <div className='sm:w-1/6'>
                                    <div className=""><img src={tool} alt="Web Dev Icon" className='sm:w-[80px] w-[60px]' /></div>
                                 </div>
                                 <div className='sm:w-4/5 2xl:px-0 lg:px-5 md:px-0 sm:px-5 sm:mt-0 mt-3'>
                                    <h3 className="text-[18px] font-bold text-black mb-2">Mobile App Design Development</h3>
                                    <p className="text-sm text-gray-600">We make your native and cross-platform apps worth drooling for.on all platforms.</p>
                                 </div>
                             </div>
                           
                        </div>
                    </div>
                    <div className="w-full  lg:w-1/2 p-0 sm:px-3 mb-6 lg:mt-3">
                        <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-100 hover:shadow-purple-md hover:cursor-pointer transition duration-300 ease-in-out relative h-full">
                            <div className="absolute top-4 right-4 bg-gradient-to-tr bg-[#F0E3FF] p-2 rounded-full"><img src={cross} alt="crossArrow" className="w-4 h-4" /></div>
                             <div className='flex sm:flex-nowrap flex-wrap items-center'>
                                 <div className='sm:w-1/6'>
                                    <div className=""><img src={box} alt="Web Dev Icon" className='sm:w-[80px] w-[60px]' /></div>
                                 </div>
                                 <div className='sm:w-4/5 2xl:px-0 lg:px-5 md:px-0 sm:px-5 sm:mt-0 mt-3'>
                                    <h3 className="text-[18px] font-bold text-black mb-2">Design Prototyping Development</h3>
                                    <p className="text-sm text-gray-600">With our prototyping services, we ensure your design works for people and process.on all platforms.</p>
                                 </div>
                             </div>
                           
                        </div>
                    </div>
                    <div className="w-full  lg:w-1/2 p-0 sm:px-3 mb-6 lg:mt-3">
                        <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-100 hover:shadow-purple-md hover:cursor-pointer transition duration-300 ease-in-out relative h-full">
                            <div className="absolute top-4 right-4 bg-gradient-to-tr bg-[#F0E3FF] p-2 rounded-full"><img src={cross} alt="crossArrow" className="w-4 h-4" /></div>
                             <div className='flex sm:flex-nowrap flex-wrap items-center'>
                                 <div className='sm:w-1/6'>
                                    <div className=""><img src={psd} alt="Web Dev Icon" className='sm:w-[80px] w-[60px]' /></div>
                                 </div>
                                 <div className='sm:w-4/5 2xl:px-0 lg:px-5 md:px-0 sm:px-5 sm:mt-0 mt-3'>
                                    <h3 className="text-[18px] font-bold text-black mb-2">PSD to HTML Development</h3>
                                    <p className="text-sm text-gray-600">Let’s turn your beautiful design layout in PSD into responsive web pages with HTML.</p>
                                 </div>
                             </div>
                           
                        </div>
                    </div>
            </div>
        </div>
        <Wave fill='#Fff' paused={false} style={{ display: 'flex' }} options={{ height: 20, amplitude: 20, speed: 0.3, points: 5}} className='relative min-w-[1920px] h-[30px]'/>
    </section>
    </div>
  )
}

export default DesignService
